// Feed naming, mirrored from the engine.
//
// Transcribed from app/feeds/factor_signal.py:163-189 (`feed_name_for_score`). The prefix is
// `score_spec_`, and the shape keys on the DECLARED SCORE COUNT — not on the score's name, and not on
// the output contract:
//
//   1 declared score, no feed_name   -> score_spec_<spec_id>              (bare)
//   N > 1, no feed_name              -> score_spec_<spec_id>__<score_name>
//   any score with feed_name         -> score_spec_<feed_name>
//
// Two consequences the form depends on.
//
// First, swapping `format_prompt` for `output_schema` is FEED-NEUTRAL as long as the id and the score
// list are unchanged — naming does not look at the contract at all. And a legacy `score_jsonpath`
// desugars to one score named `score`, giving N=1 and the same bare name it always had, which is why
// the desugar must use that name and not a descriptive one.
//
// Second, a MIGRATION of an approved spec is a new version, so the id changes and the bare name changes
// with it. Continuity therefore needs an explicit `feed_name`, and its value is derivable from the
// source alone — no lookup.
//
// `__<N>runs` variants are publish-only and never enter reverse resolution, so they are irrelevant here.

const PREFIX = 'score_spec_';

const declaredCount = (scores) => (Array.isArray(scores) ? scores.length : 0);

// The feed a score publishes to, given the spec it lives in.
export const derivedFeedName = (specId, scores, score) => {
  if (!score) return null;
  if (score.feed_name) return `${PREFIX}${score.feed_name}`;
  if (declaredCount(scores) === 1) return `${PREFIX}${specId}`;
  return `${PREFIX}${specId}__${score.name}`;
};

// The suffix a re-cut has to write to keep publishing where its source published. The source's own
// explicit name wins; otherwise it is the source's id (single score) or id__name (multi).
export const continuityFeedName = (sourceSpecId, sourceScores, score) => {
  if (!score) return null;
  if (score.feed_name) return score.feed_name;
  if (declaredCount(sourceScores) === 1) return sourceSpecId;
  return `${sourceSpecId}__${score.name}`;
};

// True when ADDING a score would rename an existing score's feed: at N=1 the name is bare, and the
// second score turns it into a suffixed one. Silent, and it breaks every consumer and pin — unless the
// score already carries an explicit feed_name, which pins it against the count.
export const feedNameChangesOnAdd = (scores) => declaredCount(scores) === 1 && !(scores[0] && scores[0].feed_name);
